import { cva } from 'class-variance-authority'

/**
 * Product Slider CVA Configuration
 *
 * Styles for homepage product slider/carousel
 */

/**
 * Product slider section container
 */
export const productSliderSectionVariants = cva('homepage-product-slider mb-8 mt-8')

/**
 * Product slider wrapper (contains swiper + navigation)
 */
export const productSliderWrapperVariants = cva('relative')

/**
 * Product slider Swiper container
 * py-3 adds vertical padding for card shadows/hover effects
 */
export const productSliderSwiperVariants = cva('product-slider-swiper py-3')

/**
 * Product slider slide
 */
export const productSliderSlideVariants = cva('!h-auto')

/**
 * Product slider skeleton grid
 * Matches the responsive slidesPerView: 1 mobile, 2 tablet, 3 desktop
 */
export const productSliderSkeletonGridVariants = cva(
  'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 py-3'
)

/**
 * Product slider grid mode container — responsive 1 col mobile / 3 cols desktop.
 * 1 col on mobile keeps the product card full-width, so no grid-specific card
 * design adjustment is needed.
 */
export const productSliderGridVariants = cva(
  'grid grid-cols-1 md:grid-cols-3 gap-0 bg-cards-bg p-1'
)

/**
 * Product slider grid item — wraps each ProductCard in grid mode.
 */
export const productSliderGridItemVariants = cva('bg-cards-bg px-1 py-2')
